
import { MouseEvent, KeyboardEvent } from 'react';

export const handleA11y = (fc: (evt: MouseEvent | KeyboardEvent) => void) => (evt: MouseEvent | KeyboardEvent) => {
    if (evt.type === 'click' || evt.type === 'keyup' && (evt as KeyboardEvent).key === 'Enter') {
        fc(evt);
    }
};